import { NgTemplateOutlet } from '@angular/common';
import { Directive, ElementRef, EmbeddedViewRef, HostListener, Input, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[appTooltip]',
    exportAs: 'apptooltip',
    standalone: false
})
export class TooltipDirective implements OnDestroy {
	constructor(
		private readonly elementRef: ElementRef,
		private readonly vcr: ViewContainerRef,
	) {}

	tooltip: any;
	elemPosition: any;
	tooltipOffset = 8;
	tooltipTemplateViewRef: EmbeddedViewRef<NgTemplateOutlet>;

	@Input('appTooltip') tooltipHTML: string | TemplateRef<NgTemplateOutlet> = '';
	@Input() placement = 'top';
	@Input() delay = 0;
	@Input() enabled = 'true';
	@Input() tooltipTemplateContext: NgTemplateOutlet<unknown>;
	@Input() tooltipDataTest: string | null = null;

	@HostListener('mouseenter')
	onMouseEnter() {
		if (this.enabled === 'true') {
			if (
				!this.tooltipHTML ||
				navigator.userAgent.match(/iPhone/i) ||
				navigator.userAgent.match(/iPod/i)
			) {
				return;
			}
			this.getElemPosition();
			document.body.appendChild(this.createElem());
			this.setPosition();
		} else {
			return;
		}
	}

	@HostListener('mouseleave')
	@HostListener('touchend')
	@HostListener('focusout')
	onMouseLeave() {
		this.removeTooltip();
	}

	ngOnDestroy() {
		this.removeTooltip();
	}

	removeTooltip() {
		this.tooltip?.parentNode?.removeChild(this.tooltip);

		const toolTips = document.querySelectorAll('[id^=tooltipId]');
		for (let i = 0; i < toolTips.length; i++) {
			toolTips[i]?.parentNode?.removeChild(toolTips[i]);
		}

		this.tooltipTemplateViewRef?.destroy();
	}

	getElemPosition() {
		this.elemPosition = this.elementRef.nativeElement.getBoundingClientRect();
	}

	createElem() {
		this.tooltip = document.createElement('span');
		this.tooltip.className += 'ng-tooltip ng-tooltip-' + this.placement;
		if (this.tooltipHTML instanceof TemplateRef) {
			this.tooltipTemplateViewRef = this.vcr.createEmbeddedView(this.tooltipHTML, this.tooltipTemplateContext);
			this.tooltipTemplateViewRef.detectChanges();
			const container = document.createElement('div');
			this.tooltipTemplateViewRef.rootNodes.forEach(node => container.appendChild(node));
			this.tooltip.appendChild(container);
		} else {
			this.tooltip.innerHTML = this.tooltipHTML;
		}
		this.tooltip.className += ' ng-tooltip-show';
		if (this.tooltipDataTest) this.tooltip.setAttribute('data-test', this.tooltipDataTest);
		return this.tooltip;
	}

	setPosition() {
		const elemHeight = this.elementRef.nativeElement.offsetHeight;
		const elemWidth = this.elementRef.nativeElement.offsetWidth;
		const tooltipHeight = this.tooltip.clientHeight;
		const tooltipWidth = this.tooltip.offsetWidth;

		this.tooltip.setAttribute('id', 'tooltipId');

		// prevent flickering
		this.tooltip.style.pointerEvents = 'none';

		if (this.placement == 'top') {
			this.tooltip.style.top =
				this.elemPosition.top +
				window.scrollY -
				(tooltipHeight + this.tooltipOffset) +
				'px';
		}

		if (this.placement == 'bottom') {
			this.tooltip.style.top =
				this.elemPosition.top +
				window.scrollY +
				elemHeight +
				this.tooltipOffset +
				'px';
		}

		if (this.placement == 'top' || this.placement == 'bottom') {
			this.tooltip.style.left =
				this.elemPosition.left + elemWidth / 2 - tooltipWidth / 2 + 'px';
		}

		if (this.placement == 'left') {
			this.tooltip.style.left =
				this.elemPosition.left - tooltipWidth - this.tooltipOffset + 'px';
		}

		if (this.placement == 'right') {
			this.tooltip.style.left =
				this.elemPosition.left + elemWidth + this.tooltipOffset + 'px';
		}

		if (this.placement == 'left' || this.placement == 'right') {
			this.tooltip.style.top =
				this.elemPosition.top +
				window.scrollY +
				elemHeight / 2 -
				this.tooltip.clientHeight / 2 +
				'px';
		}

		if (this.placement == 'none') {
			this.tooltip.style.display = 'none';
		}
	}
}
